export enum CashDroEvents {
	SCANNED = 'scanned',
	PAID = 'paid',
	CANCELLED = 'cancelled',
	FAILED = 'failed',
	IN_PAYMENT = 'in_payment',
	CHECK_AVAILABILITY_FAILED = 'checkAvailabilityFailed',
}
